var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"px-2 text-caption font-weight-regular my-1",class:_vm.classes,attrs:{"rounded":"lg","outlined":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }